import PropTypes from 'prop-types';
import { ReactNode } from 'react';
import { Dialog, DialogCloseEvent } from '@progress/kendo-react-dialogs';

interface CustomModalProps {
    closeIcon?: boolean;
    width?: string | number;
    height?: string | number;
    title: string;
    onClose?: (event: DialogCloseEvent) => void;
    body: ReactNode
}

export default function CustomModal(props: CustomModalProps) {
    return (
        <Dialog
            closeIcon={props.closeIcon === undefined ? true : props.closeIcon}
            width={props.width === undefined ? '50%' : props.width}
            minWidth={400}
            height={props.height === undefined ? 'auto' : props.height}
            title={props.title}
            onClose={props.onClose}
        >
            {props.body}
        </Dialog>
    );
}

CustomModal.propTypes = {
    body: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    closeIcon: PropTypes.bool,
    height: PropTypes.any,
    onClose: PropTypes.func,
    title: PropTypes.string,
    width: PropTypes.any,
};
